function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  fillRule: "evenodd",
  d: "M4.929 16h6.27a1.6 1.6 0 011.6 1.6v8.24L20.673 16H14.4a1.6 1.6 0 01-1.6-1.6V6.16L4.929 16zm5.741 15.909A1.599 1.599 0 019.6 30.4V19.2h-8a1.6 1.6 0 01-1.248-2.6l12.8-16A1.598 1.598 0 0116 1.6v11.2h8a1.602 1.602 0 011.25 2.6l-12.8 16a1.598 1.598 0 01-1.78.509z"
});

function SvgWinWin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 32
  }, props), _ref);
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNiIgaGVpZ2h0PSIzMiIgdmlld0JveD0iMCAwIDI2IDMyIj4KICAgIDxwYXRoIGZpbGw9IiNGRkYiIGZpbGwtcnVsZT0iZXZlbm9kZCIgZD0iTTQuOTI5IDE2aDYuMjdhMS42IDEuNiAwIDAgMSAxLjYgMS42djguMjRMMjAuNjczIDE2SDE0LjRhMS42IDEuNiAwIDAgMS0xLjYtMS42VjYuMTZMNC45MjkgMTZ6bTUuNzQxIDE1LjkwOUExLjU5OSAxLjU5OSAwIDAgMSA5LjYgMzAuNFYxOS4yaC04YTEuNiAxLjYgMCAwIDEtMS4yNDgtMi42bDEyLjgtMTZBMS41OTggMS41OTggMCAwIDEgMTYgMS42djExLjJoOGMuNjE2IDAgMS4xNzYuMzUzIDEuNDQzLjkwNy4yNjYuNTU0LjE5IDEuMjExLS4xOTMgMS42OTNsLTEyLjggMTZhMS41OTggMS41OTggMCAwIDEtMS43OC41MDl6Ii8+Cjwvc3ZnPgo=";
export { SvgWinWin as ReactComponent };